const {jQuery: $} = window;
import Utils from "./utils.class";

export default class Theme {
    $stickyContact;
    $header;

    $main;
    $html;
    $body;
    $admin;
    $root;
    $searchBtn;
    $searchModal;


    constructor() {
        this.$stickyContact = $('.contactBar');
        this.$header = $('.elementor-location-header');

        this.$html = $('html');
        this.$body = $('body');
        this.$admin = $('#wpadminbar');
        this.$root = document.querySelector(":root");
        this.$searchBtn = $("#serachbtn");
        this.$searchModal = $("#searchModal");
    }

    __onReady() {
        Utils.log("Theme Ready");
        const me = this;
        const $ucfBar = $("#ucfhb");

        console.log("UCF HB Loaded");
        $ucfBar.addClass('bar-loaded');

        $.getScript('//universityheader.ucf.edu/bar/js/university-header.js', function () {
            $('#ucf-black-bar').append($ucfBar);
        });

        this.$searchBtn.on("click", (e) => {
            e.preventDefault();
            this.$searchModal.addClass("js--open");
        });

        this.$searchModal.find(".searchModal__close").on("click", (e) => {
            e.preventDefault();

            this.$searchModal.removeClass("js--open");
        });
    }

    __onLoad() {
        Utils.log("Theme Load");
        const me = this;

        Utils.equalHeight('.elementor-widget-heading', '.virtual-hub-row');


        $('.contactBar .contactBar__control').on('click', function () {
            $('.contactBar').toggleClass('closed')
        })
        // Moves the UCF Header bar into the "header" section matching the comp

        this.$header.addClass('fixed');
        $(window).trigger("resize");
    }

    __onResize() {
        this.#updateCssHeaderHeight();
        const $ucfBar = $("#ucfhb");

        if ($(window).width() < 1025) {
            if (($('.elementor-location-header').children("#ucfhb")).length === 0) {
                $('.elementor-location-header').prepend($ucfBar);
            }
        } else {
            if (($('#ucf-black-bar').children("#ucfhb")).length === 0) {
                $ucfBar.addClass('bar-loaded');
                $('#ucf-black-bar').append($ucfBar);
            }
        }

    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.$admin.length > 0) {
            return this.$header.outerHeight() + this.$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }

    #updateCssHeaderHeight() {
        this.$root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}